export default __webpack_public_path__ + "static/media/bootstrap-grid.css.d76dda48.map";